import { defineComponent } from "vue";
import { mapState } from "pinia";

import FormSection from "../../../../../resources-vue/vue-custom-elements/FormSection/FormSection.vue";
import TypeaheadInput from "../../../../../resources-vue/vue-custom-elements/TypeaheadInput/TypeaheadInput.vue";
import PatientPhysician from "./PatientPhysician/PatientPhysician.vue";
import { useHospiceConvertToPending } from "../../store/useHospiceConvertToPending";

export default defineComponent({
    inject: ["v"],

    components: {
        FormSection,
        TypeaheadInput,
        PatientPhysician
    },

    computed: {
        ...mapState(useHospiceConvertToPending, {
            accountId: "accountId",
            patientId: "patientId",
            patient: "patientDetails"
        })
    },

    props: {
        primaryPhysicianLabel: {
            type: String,
            default: "Hospice Physician"
        }
    },

    watch: {
        certifyingPhysicianId(newValue) {
            this.certifyingPhysicianIdChanged(newValue);
        },
        attendingPhysicianId(newValue) {
            this.attendingPhysicianIdChanged(newValue);
        },
        sameAttending(newValue) {
            this.sameAttendingChanged(newValue);
        }
    },

    data() {
        return {
            lineOfServiceValue: -1 as number,
            certifyingPhysicianId: "" as string,
            attendingPhysicianId: "" as string,
            sameAttending: false as boolean,
            v$: this.v
        };
    },

    created() {
        this.lineOfServiceValue = this.patient.lineOfService;
    },

    async mounted() {
        if (this.patient.attendingPhysicianId) {
            this.attendingPhysicianId = this.patient.attendingPhysicianId;
        }
        if (this.patient.hospicePhysicianId) {
            this.certifyingPhysicianId = this.patient.hospicePhysicianId;
        }
        if (this.patient.hospicePhysicianId && this.patient.attendingPhysicianId == this.patient.hospicePhysicianId) {
            this.sameAttending = true;
        }
    },

    methods: {
        certifyingPhysicianIdChanged(id: string) {
            if (id) {
                this.patient.certifyingPhysicianId = id;
                this.patient.hospicePhysicianId = id;
                if (this.sameAttending) {
                    this.attendingPhysicianId = id;
                }
            } else {
                if (this.sameAttending) {
                    this.sameAttending = false;
                    this.attendingPhysicianId = null;
                }
                this.patient.certifyingPhysicianId = null;
                this.patient.hospicePhysicianId = null;
            }
        },

        attendingPhysicianIdChanged(id: string) {
            if (id) {
                this.patient.attendingPhysicianId = id;
            } else {
                this.patient.attendingPhysicianId = null;
            }
        },

        sameAttendingChanged(newValue: boolean) {
            if (newValue) {
                this.attendingPhysicianId = this.certifyingPhysicianId;
            }
        },

        addNewPhysician() {
            this.patient.additionalPhysicians = this.patient.additionalPhysicians.concat(null);
        }
    }
});
